<template>
<div id="a7-login-simples">
  <gw-modal-dialog :visible="show" @hide="cancelar">
    <span slot="modal-header">Logar novamente</span>
    <div slot="modal-body">
      <b>Sessão de Usuário invalidada. Efetue login novamente.</b><br>
      <span>A sessão anterior de usuário foi invalidada e por isso é necessário efetuar o login novamente.</span><br><br>
      <form class="form-horizontal" @submit.prevent="efetuarLogin">
        <div class="form-group">
          <label class="col-sm-3 control-label" for="usuario">Usuário</label>
          <div class="col-sm-9">
            <input v-model="login" type="text" id="usuario" class="form-control"></div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label" for="senha">Senha</label>
          <div class="col-sm-9">
            <input v-model="senha" type="password" id="senha" class="form-control"></div>
        </div>
      </form>
    </div>
    <div slot="modal-footer">
      <button class="btn btn-primary" type="button" name="ok" @click="efetuarLogin">Ok</button>
      <button class="btn btn-default" type="button" name="cancelar" @click="show = false">Cancelar</button>
    </div>
  </gw-modal-dialog>
</div>
</template>
<script>
import {
  GwModalDialog
} from 'guaxinim-web'
import SessaoRestResource from './SessaoRestResource'
import TokenStorage from '@/js/TokenStorage'
import md5 from 'md5'

export default {
  name: "a7-login-simples",
  components: {
    GwModalDialog
  },
  data: () => ({
    show: true,
    loggedIn: false,
    login: null,
    senha: null
  }),
  methods: {
    efetuarLogin() {
      const credencial = {
        login: !this.login ? null : this.login,
        senha: !this.senha ? null : md5(this.senha)
      }

      SessaoRestResource.login(credencial).then((response) => {
        TokenStorage.storeAuthToken(response.token)
        this.loggedIn = true
        this.show = false
      }).catch((error) => {
        this.$gw.defaultExceptionHandler.handleUnknownException(error, this)
      })

    },
    cancelar() {
      if (!this.loggedIn) {
        this.$router.push({ name: 'login' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
